import React, { useEffect, useState } from "react";
import { Grid, Paper, Icon, TextField } from "@mui/material";
import {
  Container,
  Button,
  Row,
  Col,
  Table,
  Form,
  Spinner,
} from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles";
import { PieChart, Pie, Sector, Cell, Label } from "recharts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faList,
  faFileVideo,
  faClipboard,
} from "@fortawesome/free-solid-svg-icons";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import GetAppIcon from "@mui/icons-material/GetApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { Autocomplete } from "@mui/material";
import { DateRangePicker } from "@mui/lab";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { API_URL } from "../../utils/config";
import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  paper: {
    textAlign: "center",
    color: theme.palette.text.secondary,
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Adding shadow
  },
}));

const GeneralQuizManage = () => {
  const classes = useStyles();

  const getDefaultDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = "10";
    const minutes = "00";

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  const [formData, setFormData] = useState({
    name: "",
    masterQuizId: "",
    company: localStorage.getItem("companyID"),
    passing: 80,
    questionNo: 10,
    thumbnail: null,
    dueDate: null,
    schedule: getDefaultDateTime(),
    shuffle: "yes",
    department: [],
    employees: [],
    questions: [],
    createdBy: localStorage.getItem("userId"),
  });
  const [quizMaster, setQuizMaster] = useState([]);
  const [quiz, setQuiz] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const [categoryQuiz, setCategoryQuiz] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [isGraph, setIsGraph] = useState(true);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [quizDetails, setQuizDetails] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");

  const fetchQuizDetails = async (id) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      const response = await fetch(
        `${API_URL}/quiz/${id}/details`,
        requestOptions
      );
      if (response.ok) {
        const data = await response.json();
        setQuizDetails(data);
      } else {
        console.error("Error fetching quiz details:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching quiz details:", error);
    }
  };

  useEffect(() => {
    fetchCategoryQuiz();
    fetchQuizMaster();
    fetchCompanies();
    fetchDepartments();
  }, []);

  useEffect(() => {
    fetchEmployees();
  }, [formData]); // Add formData.company to the dependencies

  useEffect(() => {
    fetchQuiz(currentPage);
  }, [currentPage]); // Add formData.company to the dependencies

  const handleFileChange = (e) => {
    setFormData({ ...formData, thumbnail: e.target.files[0] });
  };

  const fetchQuizMaster = async (currentPage) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    let apiUrl = `${API_URL}/admin/general-quiz-master`;
    fetch(apiUrl, requestOptions)
      .then((response) => {
        if (response.status == 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) => {
        setQuizMaster(result);
      })
      .catch((error) => console.error(error));
  };

  const fetchDepartments = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${API_URL}/department`, requestOptions)
        .then((response) => {
          if (response.status == 401) {
            localStorage.clear();
            window.location.reload();
            return [];
          } else {
            return response.json();
          }
        })
        .then((result) => setDepartments(result))
        .catch((error) => console.error(error));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCompanies = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(`${API_URL}/admin/companies`, requestOptions)
      .then((response) => {
        if (response.status == 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) => setCompanies(result))
      .catch((error) => console.error(error));
  };

  const fetchCategoryQuiz = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${API_URL}/categoryQuiz`, requestOptions)
        .then((response) => {
          if (response.status == 401) {
            localStorage.clear();
            window.location.reload();
            return [];
          } else {
            return response.json();
          }
        })
        .then((result) => {
          setCategoryQuiz(result);
        })
        .catch((error) => console.error(error));
    } catch (error) {
      console.error(error);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const fetchEmployees = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    let apiUrl = `${API_URL}/admin/employees?page=1&limit=10000`;
    if (formData.company) {
      apiUrl += `&companyId=${formData.company}`; // Append company ID if selected
    }
    if (formData.department.length > 0) {
      apiUrl += `&departmentId=${
        formData.department[formData.department.length - 1]._id
      }`; // Append company ID if selected
    }
    fetch(apiUrl, requestOptions)
      .then((response) => {
        if (response.status == 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) => {
        setEmployees(result.employees);
      })
      .catch((error) => console.error(error));
  };

  const fetchQuiz = async (currentPage) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    let apiUrl = `${API_URL}/admin/general-quiz`;
    apiUrl += `?companyId=${localStorage.getItem("companyID")}`; // Append company ID if selected
    fetch(apiUrl, requestOptions)
      .then((response) => {
        if (response.status == 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) => {
        setQuiz(result);
      })
      .catch((error) => console.error(error));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      var isPngOrJpg = true;
      if (formData.thumbnail) {
        const fileName = formData.thumbnail.name;
        isPngOrJpg = /\.(png|jpg)$/i.test(fileName);
      }

      if (isPngOrJpg) {
        const scheduleDate = new Date(formData.schedule);
        const dueDate = new Date(formData.dueDate);
        if (dueDate && scheduleDate > dueDate) {
          alert("Schedule date cannot be after the due date.");
        } else {
          setIsLoading(true);
          const myHeaders = new Headers();
          myHeaders.append("Authorization", localStorage.getItem("token"));
          const formdata = new FormData();
          console.log(formData.masterQuizId);
          formdata.append("masterQuizId", formData.masterQuizId);
          formdata.append("name", formData.name);
          formdata.append("company", formData.company);
          formdata.append("shuffle", formData.shuffle == "yes");
          formdata.append("passing", formData.passing);
          formdata.append("questionNo", formData.questionNo);
          if (formData.thumbnail) {
            formdata.append(
              "thumbnail",
              formData.thumbnail,
              formData.thumbnail.name
            );
          }
          formdata.append("dueDate", formData.dueDate);
          formdata.append("schedule", formData.schedule);
          formdata.append("department", JSON.stringify(formData.department));
          formdata.append("employees", JSON.stringify(formData.employees));
          formdata.append(
            "questions",
            JSON.stringify(
              formData.questions.map((question) => ({
                question: question.question,
                options: question.options,
                category: question.category,
                correctAnswer:
                  question.questionType == "single"
                    ? question.correctAnswer
                        .toString()
                        .replace("[", "")
                        .replace("]", "")
                    : question.options[question.correctAnswer],
                isMCQ: question.questionType === "MCQ",
              }))
            )
          );
          formdata.append("createdBy", formData.createdBy);
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow",
          };
          try {
            const quizResponse = await fetch(
              `${API_URL}/admin/general-quiz`,
              requestOptions
            );

            if (!quizResponse.ok) {
              throw new Error("Failed to create quiz");
            }

            setFormData({
              name: "",
              company: localStorage.getItem("companyID"),
              passing: 80,
              questionNo: 10,
              thumbnail: null,
              dueDate: null,
              schedule: getDefaultDateTime(),
              masterQuizId: "",
              department: [],
              employees: [],
              questions: [],
              createdBy: localStorage.getItem("userId"),
            });
            alert("Quiz created successfully");
            // Handle success
          } catch (error) {
            console.error("Error creating quiz:", error.message);
            alert("Error creating quiz, please try again!");
            // Handle error
          }
          fetchQuiz();
          setIsLoading(false);
        }
      } else {
        alert("Thumbnail can only contain png or jpg.");
      }
    } catch (error) {
      alert("Failed to create quiz, please try again!!");
      setIsLoading(false);
    }
  };

  const handleEdit = async (material) => {
    const now = new Date(material.schedule);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so add 1
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours() - 5).padStart(2, "0");
    const minutes = String(now.getMinutes() - 30).padStart(2, "0");
    setFormData({
      name: material.name,
      company: material.company._id,
      passing: material.passing,
      shuffle: material.shuffle ? "yes" : "no",
      questionNo: material.questionNo,
      dueDate: material.dueDate
        ? new Date(material.dueDate).toISOString().split("T")[0]
        : "",
      schedule: `${year}-${month}-${day}T${hours}:${minutes}`,
      department: material.department,
      employees: material.employees,
      questions: material.questions.map((question) => ({
        question: question.question,
        options: question.options,
        category: question.category._id,
        correctAnswer: question.isMCQ
          ? question.options.indexOf(question.correctAnswer)
          : question.correctAnswer
          ? question.correctAnswer.includes(",")
            ? question.correctAnswer
                .split(",")
                .map((numString) => parseInt(numString, 10))
            : ""
          : "",
        questionType: question.isMCQ ? "MCQ" : "single",
      })),
      createdBy: localStorage.getItem("userId"),
      quizID: material._id,
    });
    setIsEdit(true);
    await fetchEmployees();
  };

  const handleModify = async (e) => {
    e.preventDefault();
    try {
      var isPngOrJpg = true;
      if (formData.thumbnail) {
        const fileName = formData.thumbnail.name;
        isPngOrJpg = /\.(png|jpg)$/i.test(fileName);
      }

      if (isPngOrJpg) {
        const scheduleDate = new Date(formData.schedule);
        const dueDate = new Date(formData.dueDate);
        if (dueDate && scheduleDate > dueDate) {
          alert("Schedule date cannot be after the due date.");
        } else {
          setIsLoading(true);
          const myHeaders = new Headers();
          myHeaders.append("Authorization", localStorage.getItem("token"));
          const formdata = new FormData();
          formdata.append("name", formData.name);
          formdata.append("company", formData.company);
          formdata.append("passing", formData.passing);
          formdata.append("shuffle", formData.shuffle == "yes");
          formdata.append("questionNo", formData.questionNo);
          if (formData.thumbnail) {
            formdata.append(
              "thumbnail",
              formData.thumbnail,
              formData.thumbnail.name
            );
          }
          formdata.append("dueDate", formData.dueDate);
          formdata.append("schedule", formData.schedule);
          formdata.append("department", JSON.stringify(formData.department));
          formdata.append("employees", JSON.stringify(formData.employees));
          formdata.append(
            "questions",
            JSON.stringify(
              formData.questions.map((question) => ({
                question: question.question,
                options: question.options,
                category: question.category,
                correctAnswer:
                  question.questionType == "single"
                    ? question.correctAnswer
                        .toString()
                        .replace("[", "")
                        .replace("]", "")
                    : question.options[question.correctAnswer],
                isMCQ: question.questionType === "MCQ",
              }))
            )
          );
          formdata.append("createdBy", formData.createdBy);
          const requestOptions = {
            method: "PUT",
            headers: myHeaders,
            body: formdata,
            redirect: "follow",
          };
          try {
            const surveyResponse = await fetch(
              `${API_URL}/admin/general-quiz/${formData.quizID}`,
              requestOptions
            );

            if (!surveyResponse.ok) {
              alert("Error updating survey, please try again!");
              throw new Error("Failed to create survey");
            }

            alert("Quiz updated successfully");
            setFormData({
              name: "",
              company: localStorage.getItem("companyID"),
              passing: 80,
              questionNo: 10,
              thumbnail: null,
              shuffle: "yes",
              dueDate: null,
              schedule: getDefaultDateTime(),
              masterQuizId: "",
              department: [],
              employees: [],
              questions: [],
              createdBy: localStorage.getItem("userId"),
            });
          } catch (error) {
            alert("Error updating survey, please try again!");
            console.error("Error creating survey:", error.message);
            // Handle error
          }
          fetchQuiz();
          setIsEdit(false);
          setIsLoading(false);
        }
      } else {
        alert("Thumbnail can only contain png or jpg.");
      }
    } catch (error) {
      alert("Error updating survey, please try again!");
      setIsLoading(false);
    }
  };

  const handleDelete = (courseID) => {
    // Display confirmation popup before deleting
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this quiz?"
    );
    if (!isConfirmed) return; // If user cancels, do nothing

    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(
      `${API_URL}/admin/general-quiz/${courseID}`,
      requestOptions
    )
      .then((result) => {
        if (result.ok) {
          alert("Quiz deleted successfully");
          fetchQuiz();
        }
      })
      .catch((error) => console.error(error));
  };

  const handleEmployeeChange = (event, newValue) => {
    if (newValue) {
      if (newValue.some((option) => option.id === "select-all")) {
        setFormData((formData) => {
          var ids = new Set(formData.employees.map((d) => d._id));
          var merged = [
            ...formData.employees,
            ...employees.filter((d) => !ids.has(d._id)),
          ];
          return { ...formData, employees: merged };
        });
      } else {
        setFormData((formData) => {
          let removeCount = 0;
          let addCount = 0;
          formData.employees.forEach((preObj) => {
            const found = newValue.find(
              (newObj) => JSON.stringify(newObj) == JSON.stringify(preObj)
            );
            if (!found) {
              removeCount++;
            }
          });
          newValue.forEach((newObj) => {
            const found = formData.employees.find(
              (prevObj) => JSON.stringify(prevObj) == JSON.stringify(newObj)
            );
            if (!found) {
              addCount++;
            }
          });
          var ids = new Set(formData.employees.map((d) => d._id));
          var merged = [
            ...formData.employees,
            ...newValue.filter((d) => !ids.has(d._id)),
          ];
          return {
            ...formData,
            employees:
              removeCount > 0 ? newValue.filter((d) => ids.has(d._id)) : merged,
          };
        });
      }
    }
  };

  const handleWeightageChange = (e, categoryIndex) => {
    const newCategories = [...formData.categories];
    newCategories[categoryIndex].weightage = parseInt(e.target.value) || 0; // Convert to integer
    console.log(newCategories);
    setFormData({ ...formData, categories: newCategories });
  };

  const handleFetchGraphData = (material) => {
    console.log(material);
    fetchQuizDetails(material._id);
    setIsGraph(false);
  };

  const handleDownloadAnswers = async (surveyId) => {
    try {
      const response = await fetch(
        `${API_URL}/surveyAnswers/${surveyId}`
      );
      const data = await response.json();

      // Define the CSV content
      let csvContent =
        "Students Name,Students Email,Students Department,Students School,Survey Question,Selected Option,Selected Weightage\n";

      // Loop through each survey answer and add to the CSV content
      data.forEach((answer) => {
        csvContent += `"${answer.employeeName}","${answer.employeeEmail}","${answer.employeeDepartment}","${answer.employeeCompany}","${answer.surveyQuestion}","${answer.selectedOption}","${answer.selectedWeightage}"\n`;
      });

      // Create a Blob object with the CSV data
      const blob = new Blob([csvContent], { type: "text/csv" });

      // Create a temporary anchor element
      const anchor = document.createElement("a");
      anchor.href = window.URL.createObjectURL(blob);
      anchor.download = "survey_answers.csv";
      anchor.click();
    } catch (error) {
      console.error("Error downloading answers:", error);
      // Handle error
    }
  };

  const options = [
    { id: "select-all", firstName: "Select", lastName: "All" }, // Select All option
    ...employees,
  ];

  const filteredData =
    selectedCategories.length > 0
      ? graphData.filter((item) =>
          selectedCategories.some(
            (category) => category._id === item.categoryId
          )
        )
      : graphData;
  const averageScore = filteredData
    .map((category) => category.Current)
    .reduce((acc, cur, _, arr) => acc + cur / arr.length, 0);

  return (
    <Grid
      item
      xs={10}
      style={{
        padding: "20px",
        height: "100%",
        fontFamily: "Noto Sans",
        fontWeight: "500",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Container fluid style={{ height: "100%" }}>
        {isGraph ? (
          <Row>
            <Col
              xs={12}
              style={{
                flex: 1,
                height: "90vh",
                width: "100%",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div style={{ width: "100%" }}>
                {quiz.length > 0 ? (
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Total Questions</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* Map through companies data to display each company */}
                      {quiz.map((material) => {
                        return (
                          <tr key={material._id}>
                            <td
                              style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-evenly",
                              }}
                              onClick={() => handleFetchGraphData(material)}
                            >
                              <div
                                style={{
                                  backgroundColor:
                                    new Date() < new Date(material.schedule)
                                      ? "grey"
                                      : new Date() >=
                                          new Date(material.schedule) &&
                                        new Date() <= new Date(material.dueDate)
                                      ? "green"
                                      : "red",
                                  width: "10px",
                                  height: "50px",
                                }}
                              />
                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "start",
                                  marginLeft: "10px",
                                  justifyContent: "space-evenly",
                                }}
                              >
                                {material.name}
                                <p
                                  style={{
                                    margin: "0px",
                                    padding: "0px",
                                    fontSize: "10px",
                                  }}
                                >
                                  {material._id}
                                </p>
                              </div>
                            </td>
                            <td onClick={() => handleFetchGraphData(material)}>
                              {material.questions.length}
                            </td>
                            <td>
                              <EditNoteIcon
                                onClick={() => handleEdit(material)}
                                style={{ color: "green", cursor: "pointer" }}
                              />
                              <DeleteSweepIcon
                                onClick={() => handleDelete(material._id)}
                                style={{ color: "red", cursor: "pointer" }}
                              />
                              {/* <GetAppIcon onClick={() => handleDownloadAnswers(material._id)} style={{ color: 'blue', cursor: 'pointer' }} /> */}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                ) : (
                  <div style={{ margin: "20px", textAlign: "center" }}>
                    No quiz found, please try again!
                  </div>
                )}
              </div>
              <div style={{ flex: 1 }} />
              <nav aria-label="Courses pagination">
                <ul className="pagination">
                  {[...Array(totalPages).keys()].map((page) => (
                    <li
                      key={page}
                      className={`page-item ${
                        currentPage === page + 1 ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(page + 1)}
                      >
                        {page + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            </Col>
            <Col xs={4} style={{ height: "82vh", overflowY: "auto" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "15px",
                }}
              >
                <h4>{isEdit ? "Edit" : "Create"} Quiz</h4>
                <Button
                  variant="secondary"
                  onClick={() => {
                    setFormData({
                      name: "",
                      company: localStorage.getItem("companyID"),
                      passing: 80,
                      questionNo: 10,
                      thumbnail: null,
                      shuffle: "yes",
                      masterQuizId: "",
                      dueDate: null,
                      schedule: getDefaultDateTime(),
                      department: [],
                      employees: [],
                      questions: [],
                      createdBy: localStorage.getItem("userId"),
                    });
                    setIsEdit(false);
                  }}
                >
                  Cancel
                </Button>
              </div>
              <Form.Group
                controlId={`formsurveyname`}
                style={{ marginBottom: "10px" }}
              >
                <Form.Label style={{ fontWeight: "500", borderRadius: "20px" }}>
                  Quiz Name
                </Form.Label>
                <Form.Control
                  className="w-100"
                  style={{ width: "100%", borderRadius: "5px" }}
                  type="text"
                  placeholder="Enter the quiz name"
                  value={formData.name}
                  onChange={(e) => {
                    setFormData({ ...formData, name: e.target.value });
                  }}
                />
              </Form.Group>
              {isEdit ? null : (
                <div>
                  <div style={{ height: "5px" }} />
                  <Form.Group
                    controlId="formCompanyFilter"
                    style={{ marginBottom: "10px" }}
                  >
                    <Form.Label
                      style={{ fontWeight: "500", borderRadius: "20px" }}
                    >
                      Quiz Template
                    </Form.Label>
                    <Form.Control
                      className="w-100"
                      style={{ width: "100%", borderRadius: "5px" }}
                      as="select"
                      value={formData.masterQuizId}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          masterQuizId: e.target.value,
                        });
                      }}
                    >
                      <option value="">Select a quiz template</option>
                      {quizMaster.map((company) => (
                        <option key={company._id} value={company._id}>
                          {company.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </div>
              )}
              <div style={{ height: "5px" }} />
              <Form.Label style={{ fontWeight: "500", borderRadius: "20px" }}>
                Department Name
              </Form.Label>
              <Autocomplete
                multiple
                id="formDepartmentFilter"
                options={departments}
                value={formData.department}
                getOptionLabel={(option) => option.name}
                onChange={(event, newValue) => {
                  setFormData({ ...formData, department: newValue });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined" // Set background color to blue
                  />
                )}
              />
              <div style={{ height: "5px" }} />
              <Form.Label style={{ fontWeight: "500", borderRadius: "20px" }}>
                Students Name
              </Form.Label>
              <Autocomplete
                multiple
                id="formEmployeeFilter"
                options={options}
                getOptionLabel={(option) =>
                  `${option.firstName} ${option.lastName}`
                }
                value={formData.employees}
                onChange={handleEmployeeChange}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField {...params} label="Students" variant="outlined" />
                )}
              />
              {formData.masterQuizId ? null : (
                <div>
                  <div style={{ height: "10px" }} />
                  <Form.Group>
                    <Form.Label
                      style={{ fontWeight: "500", borderRadius: "20px" }}
                    >
                      Passing Percentage
                    </Form.Label>
                    <Form.Control
                      className="w-100"
                      style={{ width: "100%", borderRadius: "20px" }}
                      type="number"
                      value={formData.passing}
                      onChange={(e) =>
                        setFormData({ ...formData, passing: e.target.value })
                      }
                    />
                  </Form.Group>

                  <div style={{ height: "10px" }} />
                  <Form.Group>
                    <Form.Label
                      style={{ fontWeight: "500", borderRadius: "20px" }}
                    >
                      No of Question for Quiz
                    </Form.Label>
                    <Form.Control
                      className="w-100"
                      style={{ width: "100%", borderRadius: "20px" }}
                      type="number"
                      value={formData.questionNo}
                      onChange={(e) =>
                        setFormData({ ...formData, questionNo: e.target.value })
                      }
                    />
                  </Form.Group>
                  <Form>
                    <Form.Group>
                      <Form.Label>Shuffle</Form.Label>
                      <div style={{ flexDirection: "row", display: "flex" }}>
                        <Form.Check
                          type="radio"
                          label="Yes"
                          name="yesNoOptions"
                          value="yes"
                          checked={formData.shuffle === "yes"}
                          onChange={(e) =>
                            setFormData({ ...formData, shuffle: "yes" })
                          }
                          id="yesOption"
                        />
                        <div style={{ width: "20px" }} />
                        <Form.Check
                          type="radio"
                          label="No"
                          name="yesNoOptions"
                          value="no"
                          checked={formData.shuffle === "no"}
                          onChange={(e) =>
                            setFormData({ ...formData, shuffle: "no" })
                          }
                          id="noOption"
                        />
                      </div>
                    </Form.Group>
                  </Form>
                  <div style={{ height: "10px" }} />
                </div>
              )}
              {/* <Form.Group>
                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Weightage</Form.Label>
                        <Form.Control
                            className="w-100"
                            style={{ width: '100%', borderRadius: '20px' }}
                            type="number"
                            value={formData.shuffle}
                            onChange={(e) => setFormData({ ...formData, dueDate: e.target.value })}
                        />
                    </Form.Group> */}
              {isLoading ? null : (
                <Form.Group controlId="formCompanyLogo">
                  <Form.Label
                    style={{ fontWeight: "500", borderRadius: "20px" }}
                  >
                    Upload Thumbnail
                  </Form.Label>
                  <Form.Control
                    type="file"
                    className="w-100"
                    placeholder="Select Thumbnail"
                    accept=".png,.jpg,.jpeg"
                    onChange={handleFileChange}
                    style={{ width: "100%", borderRadius: "20px" }}
                  />
                </Form.Group>
              )}
              <div style={{ height: "10px" }} />
              <Form.Group controlId="dueDate">
                <Form.Label>Due Date:</Form.Label>
                <Form.Control
                  type="date"
                  value={formData.dueDate}
                  onChange={(e) =>
                    setFormData({ ...formData, dueDate: e.target.value })
                  }
                  required
                  style={{ marginBottom: "10px" }}
                />
              </Form.Group>

              <div style={{ height: "10px" }} />
              <Form.Group controlId="scheduleDate">
                <Form.Label>Schedule Quiz:</Form.Label>
                <Form.Control
                  type="datetime-local"
                  value={formData.schedule}
                  onChange={(e) =>
                    setFormData({ ...formData, schedule: e.target.value })
                  }
                  required
                  style={{ marginBottom: "10px" }}
                />
              </Form.Group>
              <div style={{ height: "10px" }} />
              {formData.masterQuizId
                ? null
                : formData.questions.map((question, questionIndex) => (
                    <div
                      key={questionIndex}
                      style={{
                        backgroundColor: "#F6F6F6",
                        marginBottom: "10px",
                        padding: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <h5
                          style={{
                            fontWeight: "500",
                            borderRadius: "20px",
                            alignSelf: "center",
                          }}
                        >
                          Question {questionIndex + 1}
                        </h5>
                        <DeleteSweepIcon
                          onClick={() => {
                            const newQuestions = [...formData.questions];
                            newQuestions.splice(questionIndex, 1); // Remove question
                            setFormData({
                              ...formData,
                              questions: newQuestions,
                            });
                          }}
                          style={{ color: "red", cursor: "pointer" }}
                        />
                      </div>
                      <Form.Group controlId={`formCategory${questionIndex}`}>
                        <Form.Label
                          style={{ fontWeight: "500", borderRadius: "20px" }}
                        >
                          Category
                        </Form.Label>
                        <Form.Control
                          className="w-100"
                          style={{ width: "100%", borderRadius: "20px" }}
                          as="select"
                          value={question.category}
                          onChange={(e) => {
                            const newQuestions = [...formData.questions];
                            newQuestions[questionIndex].category =
                              e.target.value;
                            setFormData({
                              ...formData,
                              questions: newQuestions,
                            });
                          }}
                        >
                          <option value="">Select a category</option>
                          {categoryQuiz.map((category) => (
                            <option key={category._id} value={category._id}>
                              {category.name}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                      <Form.Group
                        controlId={`formQuestionType${questionIndex}`}
                      >
                        <div
                          style={{
                            flexDirection: "row",
                            display: "flex",
                            alignItems: "center",
                            marginTop: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          <Form.Label
                            style={{
                              fontWeight: "500",
                              borderRadius: "20px",
                              margin: "0px",
                              padding: "0px",
                            }}
                          >
                            Question Type:
                          </Form.Label>
                          <div style={{ width: "10px" }} />
                          <Form.Check
                            type="radio"
                            label="MCQ"
                            checked={question.questionType === "MCQ"}
                            onChange={(e) => {
                              const newQuestions = [...formData.questions];
                              newQuestions[questionIndex].questionType = "MCQ";
                              newQuestions[questionIndex].correctAnswer = 0;
                              newQuestions[questionIndex].options = [
                                ...Array(4),
                              ];
                              setFormData({
                                ...formData,
                                questions: newQuestions,
                              });
                            }}
                          />
                          <div style={{ width: "10px" }} />
                          <Form.Check
                            type="radio"
                            label="Single"
                            checked={question.questionType === "single"}
                            onChange={(e) => {
                              const newQuestions = [...formData.questions];
                              newQuestions[questionIndex].questionType =
                                "single";
                              newQuestions[questionIndex].correctAnswer = [];
                              newQuestions[questionIndex].options = [
                                ...Array(4),
                              ];
                              setFormData({
                                ...formData,
                                questions: newQuestions,
                              });
                            }}
                          />
                        </div>
                      </Form.Group>
                      {question.questionType === "MCQ" && (
                        <div>
                          <Form.Group controlId="formQuestion">
                            <Form.Label
                              style={{
                                fontWeight: "500",
                                borderRadius: "20px",
                              }}
                            >
                              Question
                            </Form.Label>
                            <Form.Control
                              className="w-100"
                              style={{ width: "100%", borderRadius: "20px" }}
                              type="text"
                              as="textarea"
                              rows={2}
                              placeholder="Enter the question"
                              value={question.question}
                              onChange={(e) => {
                                const newQuestions = [...formData.questions];
                                newQuestions[questionIndex].question =
                                  e.target.value;
                                setFormData({
                                  ...formData,
                                  questions: newQuestions,
                                });
                              }}
                            />
                          </Form.Group>
                          {/* Options */}
                          <Form.Group controlId={`formOptions${questionIndex}`}>
                            <Form.Label
                              style={{
                                fontWeight: "500",
                                borderRadius: "20px",
                              }}
                            >
                              Options
                            </Form.Label>
                            {question.options.map((option, index) => (
                              <div
                                key={index}
                                className="mb-3"
                                style={{
                                  flexDirection: "row",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Form.Check
                                  type="radio"
                                  id={`option${index}`}
                                  name={`correctAnswer${questionIndex}`}
                                  value={index}
                                  checked={question.correctAnswer === index}
                                  onChange={(e) => {
                                    const newQuestions = [
                                      ...formData.questions,
                                    ];
                                    newQuestions[questionIndex].correctAnswer =
                                      index;
                                    setFormData({
                                      ...formData,
                                      questions: newQuestions,
                                    });
                                  }}
                                />
                                <div style={{ width: "10px" }} />
                                <Form.Control
                                  className="w-100"
                                  style={{
                                    width: "100%",
                                    borderRadius: "20px",
                                  }}
                                  type="text"
                                  value={option}
                                  placeholder={`Option ${index + 1}`}
                                  onChange={(e) => {
                                    const newQuestions = [
                                      ...formData.questions,
                                    ];
                                    const newOptions = [...question.options];
                                    newOptions[index] = e.target.value;
                                    newQuestions[questionIndex].options =
                                      newOptions;
                                    setFormData({
                                      ...formData,
                                      questions: newQuestions,
                                    });
                                  }}
                                />
                              </div>
                            ))}
                          </Form.Group>
                        </div>
                      )}
                      {question.questionType === "single" && (
                        <div>
                          <Form.Group controlId="formQuestion">
                            <Form.Label
                              style={{
                                fontWeight: "500",
                                borderRadius: "20px",
                              }}
                            >
                              Question
                            </Form.Label>
                            <Form.Control
                              className="w-100"
                              style={{ width: "100%", borderRadius: "20px" }}
                              type="text"
                              as="textarea"
                              rows={2}
                              placeholder="Enter the question"
                              value={question.question}
                              onChange={(e) => {
                                const newQuestions = [...formData.questions];
                                newQuestions[questionIndex].question =
                                  e.target.value;
                                setFormData({
                                  ...formData,
                                  questions: newQuestions,
                                });
                              }}
                            />
                          </Form.Group>
                          {/* Options */}
                          <Form.Group controlId={`formOptions${questionIndex}`}>
                            <Form.Label
                              style={{
                                fontWeight: "500",
                                borderRadius: "20px",
                              }}
                            >
                              Options
                            </Form.Label>
                            {question.options.map((option, index) => (
                              <div
                                key={index}
                                className="mb-3"
                                style={{
                                  flexDirection: "row",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Form.Check
                                  type="checkbox" // Change type to "checkbox"
                                  id={`option${index}`}
                                  name={`correctAnswer${questionIndex}`}
                                  value={index}
                                  checked={question.correctAnswer.includes(
                                    index
                                  )} // Check if the index is included in correctAnswer array
                                  onChange={() => {
                                    const newQuestions = [
                                      ...formData.questions,
                                    ];
                                    const newCorrectAnswer =
                                      question.correctAnswer.includes(index)
                                        ? question.correctAnswer.filter(
                                            (item) => item !== index
                                          )
                                        : [
                                            ...newQuestions[questionIndex]
                                              .correctAnswer,
                                            index,
                                          ];
                                    newQuestions[questionIndex].correctAnswer =
                                      newCorrectAnswer;
                                    setFormData({
                                      ...formData,
                                      questions: newQuestions,
                                    });
                                  }}
                                />
                                <div style={{ width: "10px" }} />
                                <Form.Control
                                  className="w-100"
                                  style={{
                                    width: "100%",
                                    borderRadius: "20px",
                                  }}
                                  type="text"
                                  placeholder={`Option ${index + 1}`}
                                  value={option}
                                  onChange={(e) => {
                                    const newQuestions = [
                                      ...formData.questions,
                                    ];
                                    const newOptions = [...question.options];
                                    newOptions[index] = e.target.value;
                                    newQuestions[questionIndex].options =
                                      newOptions;
                                    setFormData({
                                      ...formData,
                                      questions: newQuestions,
                                    });
                                  }}
                                />
                              </div>
                            ))}
                          </Form.Group>
                        </div>
                      )}
                    </div>
                  ))}
              {/* Add question button */}
              {formData.masterQuizId ? null : (
                <Button
                  variant="outline-primary"
                  size="sm"
                  elevation={3}
                  className="w-100"
                  style={{
                    fontWeight: "600",
                    borderRadius: "20px",
                    marginBottom: "10px",
                  }}
                  onClick={() => {
                    setFormData((prevState) => ({
                      ...prevState,
                      questions: [
                        ...prevState.questions,
                        {
                          question: "",
                          options: [{ optionText: "", weightage: "" }],
                        },
                      ],
                    }));
                  }}
                >
                  Add Question
                </Button>
              )}
              {formData.masterQuizId ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <p>
                    *If thumbnail is not selected default thumbnail from the
                    quiz template will be used!
                  </p>
                  <p>
                    **Editing of quiz is available once the quiz has been
                    created.
                  </p>
                </div>
              ) : null}
              <Button
                onClick={isEdit ? handleModify : handleSubmit}
                style={{
                  fontWeight: "600",
                  borderRadius: "20px",
                  marginTop: "5px",
                }}
                elevation={3}
                className="w-100"
                variant="primary"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : null}
                {isEdit ? "Modify" : "Create"} Quiz
              </Button>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col
              xs={12}
              style={{
                overflowY: "scroll",
                flex: 1,
                width: "100%",
                height: "83vh",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "start",
              }}
            >
              <div
                style={{
                  width: "100%",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  marginBottom: "15px",
                  marginTop: "10px",
                  justifyContent: "space-between",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div style={{ flex: 1 }} />
                <div>
                  <Button
                    variant="outline-primary"
                    style={{
                      fontWeight: "600",
                      borderRadius: "5px",
                      marginLeft: "10px",
                    }}
                    onClick={() => {
                      const input = document.getElementById("divToPrint");

                      html2canvas(input, { scale: 2 }).then((canvas) => {
                        const imgData = canvas.toDataURL("image/jpeg", 1.0);
                        const pdf = new jsPDF("p", "mm", "a4");
                        const imgProps = pdf.getImageProperties(imgData);
                        const pdfWidth = pdf.internal.pageSize.getWidth();
                        const pdfHeight =
                          (imgProps.height * pdfWidth) / imgProps.width;

                        pdf.addImage(
                          imgData,
                          "JPEG",
                          0,
                          0,
                          pdfWidth,
                          pdfHeight
                        );
                        pdf.save("download.pdf");
                      });
                    }}
                  >
                    Download PDF
                  </Button>
                  <Button
                    style={{
                      fontWeight: "600",
                      borderRadius: "5px",
                      marginLeft: "10px",
                    }}
                    elevation={3}
                    variant="primary"
                    type="submit"
                    disabled={isLoading}
                    onClick={(event) => {
                      event.preventDefault();
                      setIsGraph(true);
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
              <Grid id="divToPrint" container style={{ marginTop: "10px" }}>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Quiz Name</th>
                      <th>Attempts</th>
                      <th>Percentage</th>
                      <th>Pass/Fail</th>
                      <th>Completion Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {quizDetails
                      ? quizDetails.attempts.map((attempt, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{attempt.employee.firstName}</td>
                            <td>{attempt.employee.lastName}</td>
                            <td>{attempt.employee.email}</td>
                            <td>{quizDetails.quizName}</td>
                            <td>{index + 1}</td>{" "}
                            {/* Assuming attempt number is index + 1 */}
                            <td>{attempt.percentage}%</td>
                            <td>{attempt.isFail ? "Fail" : "Pass"}</td>
                            <td>{new Date(attempt.time).toLocaleString()}</td>
                          </tr>
                        ))
                      : null}
                  </tbody>
                </Table>
              </Grid>
            </Col>
          </Row>
        )}
      </Container>
    </Grid>
  );
};

export default GeneralQuizManage;
